import React from "react";
import {
  Route,
  withRouter,
} from "react-router-dom";
import classnames from "classnames";

// styles
import useStyles from "../styles";

// components
import Header from "../../Header/Header";
import Sidebar from "../../Sidebar/Sidebar";

// pages
import Dashboard from "../../../pages/dashboard/Dashboard";
import { Push } from "../../../pages/pushNotifications/actions/list";
import { ReceivedPayments } from "../../../pages/payment/client/actions/list";
// import AnalyticsIntegration from "../../../pages/analyticsIntegration";

// context
import { useLayoutState } from "../../../context/LayoutContext";

function LayoutClient(props) {
  var classes = useStyles();

  // global
  var layoutState = useLayoutState();

  return (
    <div className={classes.root}>
        <>
          <Header history={props.history} />
          <Sidebar />
          <div
            className={classnames(classes.content, {
              [classes.contentShift]: layoutState.isSidebarOpened,
            })}
          >
            <div className={classes.fakeToolbar} />
              <Route path="/dashboard" component={Dashboard} />
              <Route path="/receivedPayments" component={ReceivedPayments} />
              {/* <Route path="/analyticsIntegration" component={AnalyticsIntegration} /> */}
            {(localStorage.getItem('publisher-BrowserNotification') === "true" ?
            <Route path="/pushNotifications" component={Push} /> : <Route></Route>)}
          </div>
        </>
    </div>
  );
}

export default withRouter(LayoutClient);
